// Pure helpers for editing SVG colors from the floating toolbar. Mirrors the
// recolor model RightSidebar/SvgPaletteEditor use: uploaded SVGs carry a
// `colorMap` (original hex -> current hex) applied by processSvgForRender;
// Memphis/tint SVGs (no colorMap) use a single `fill`. A separate `stroke`
// overlay object handles outline color. Editing colorMap/fill/stroke persists
// through save/load, thumbnails, and export because all render paths read them.

export function getSvgColorCapabilities(element) {
  if (!element || element.type !== 'svg') {
    return { hasEditableFills: false, hasStroke: false, usesPalette: false, editableColors: [] };
  }
  const hasColorMap = element.colorMap && typeof element.colorMap === 'object';
  const editableColors = hasColorMap ? Object.keys(element.colorMap) : [];
  const usesPalette = editableColors.length > 0;
  // Palette SVGs always have fills; otherwise the single `fill` (Memphis) or a
  // tint (uploaded SVG with no detected colors) is editable.
  const hasEditableFills = usesPalette || hasColorMap || element.fill != null || !!element.svgContent;
  return { hasEditableFills, hasStroke: true, usesPalette, editableColors };
}

// Recolor every SVG color to one value. Palette SVGs remap all colorMap
// entries; tint/Memphis SVGs just set `fill`.
export function recolorAllPatch(element, newColor) {
  const caps = getSvgColorCapabilities(element);
  if (caps.usesPalette) {
    const colorMap = {};
    for (const k of Object.keys(element.colorMap)) colorMap[k] = newColor;
    return { colorMap, fill: newColor };
  }
  return { fill: newColor };
}

// Recolor a single original color in the palette, preserving the others.
export function setSvgColorPatch(element, originalColor, newColor) {
  return { colorMap: { ...(element.colorMap || {}), [originalColor]: newColor } };
}
